// src/components/PrelaunchWrapper.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PrelaunchWrapper = ({ children, isPrelaunch }) => {
  const location = useLocation();

  if (isPrelaunch && location.pathname !== '/' && location.pathname !== '/affiliate') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrelaunchWrapper;